import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
//import CardFooter from '@material-ui/core/CardFooter'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import Grid from '@material-ui/core/Grid'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Loader from 'components/general/Loader'
import BrokerAPI from 'config/api/BrokerAPI'
import { onError } from 'config/lib/errorLib'
import filterFactory, { textFilter, selectFilter, numberFilter } from 'react-bootstrap-table2-filter'
import { getProductString } from 'config/helpers/Helpers'
import { NotificationManager } from 'react-notifications'
import cellEditFactory from 'react-bootstrap-table2-editor'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'

const useStyles = makeStyles(componentStyles)

function AllocationsTable(props) {
    const classes = { ...useStyles() }
    const api = new BrokerAPI()

    //const brokers = props.brokers
    const product = props.product
    const companyDetails = props.companyDetails
    const allocated = props.allocated
    const weekView = props.weekView || 'this-week'
    const delivery = props.delivery
    const onDeliveryUpdated = props.onDeliveryUpdated
    const onLiveAllocationsChange = props.onLiveAllocationsChange

    // Use nextAllocations from company record if viewing next week, otherwise current allocations
    const allocations = (weekView === 'next-week' && companyDetails.nextAllocations && companyDetails.nextAllocations[product])
        ? companyDetails.nextAllocations[product]
        : (companyDetails.allocations && companyDetails.allocations[product] ? companyDetails.allocations[product] : {})
    const extraAllocations = (companyDetails.extraAllocations && companyDetails.extraAllocations[product]) ? companyDetails.extraAllocations[product] : {}
    const dailyCaps = (companyDetails.dailyCaps && companyDetails.dailyCaps[product]) ? companyDetails.dailyCaps[product] : {}
    const weeklyLimit = props.weeklyLimit

    let updatedBrokers = []
    for (let broker of props.brokers) {
        if (!broker.products || broker.products[0] === 'All' || broker.products.indexOf(product) > -1) {
            broker['weeklyAllocation'] = allocations[broker.brokerId] ? allocations[broker.brokerId] : 0
            broker['extraAllocation'] = extraAllocations[broker.brokerId] ? extraAllocations[broker.brokerId] : 0
            broker['dailyCap'] = dailyCaps[broker.brokerId] ? dailyCaps[broker.brokerId] : 0
            updatedBrokers.push(broker)
        }
    }
    // highest weekly allocation first, then alphabetical
    updatedBrokers.sort((a, b) => {
        let aAllocation = allocations[a.brokerId] ? parseInt(allocations[a.brokerId]) : 0
        let bAllocation = allocations[b.brokerId] ? parseInt(allocations[b.brokerId]) : 0
        const diff = bAllocation - aAllocation
        if (diff !== 0) return diff
        const nameA = (a.firstName + ' ' + a.lastName).toLowerCase()
        const nameB = (b.firstName + ' ' + b.lastName).toLowerCase()
        return nameA.localeCompare(nameB)
    })
    // updatedBrokers.map((broker) => {
    //     broker['weeklyAllocation'] = allocations[broker.brokerId] ? allocations[broker.brokerId] : 0
    //     broker['extraAllocation'] = extraAllocations[broker.brokerId] ? extraAllocations[broker.brokerId] : 0
    //     broker['dailyCap'] = dailyCaps[broker.brokerId] ? dailyCaps[broker.brokerId] : 0
    // })
    //console.log('brokers: ', updatedBrokers)

    //const [allocations, setAllocations] = useState(companyDetails.allocations[product])
    //const [dailyCaps, setDailyCaps] = useState(companyDetails.dailyCaps[product])
    //const [editAllocations, setEditAllocations] = useState(false)
    const isLocalhost = window.location.hostname === 'localhost'
    const isAdmin = props.details && props.details.email && props.details.email.endsWith('@brokerdiary.io')
    const canEditThisWeek = isLocalhost || isAdmin
    const [loading, setLoading] = useState(false)
    const [brokers, setBrokers] = useState(updatedBrokers)
    const [unsavedChanges, setUnsavedChanges] = useState(false)
    const [invalidAllocations, setInvaildAllocations] = useState(false)
    const [showAll, setShowAll] = useState(false)

    // Compute which broker IDs have allocation > 0 for each view separately
    const thisWeekAllocations = companyDetails.allocations[product] ? companyDetails.allocations[product] : {}
    const savedNextWeekAllocations = (companyDetails.nextAllocations && companyDetails.nextAllocations[product])
        ? companyDetails.nextAllocations[product]
        : thisWeekAllocations
    const [thisWeekAllocatedIds] = useState(() =>
        new Set(Object.keys(thisWeekAllocations).filter(id => parseInt(thisWeekAllocations[id]) > 0))
    )
    const [nextWeekAllocatedIds, setNextWeekAllocatedIds] = useState(() =>
        new Set(Object.keys(savedNextWeekAllocations).filter(id => parseInt(savedNextWeekAllocations[id]) > 0))
    )
    const allocatedBrokerIds = weekView === 'next-week' ? nextWeekAllocatedIds : thisWeekAllocatedIds
    const [nextWeekAllocations, setNextWeekAllocations] = useState(
        (companyDetails.nextAllocations && companyDetails.nextAllocations[product])
            ? companyDetails.nextAllocations[product]
            : (companyDetails.allocations[product] ? companyDetails.allocations[product] : {})
    )

    // Re-sync broker rows whenever the week view toggles
    useEffect(() => {
        const thisWeekAllocations = companyDetails.allocations[product] ? companyDetails.allocations[product] : {}
        const currentAllocations = weekView === 'next-week'
            ? (Object.keys(nextWeekAllocations).length > 0 ? nextWeekAllocations : thisWeekAllocations)
            : thisWeekAllocations
        const resyncedBrokers = props.brokers
            .filter(broker => !broker.products || broker.products[0] === 'All' || broker.products.indexOf(product) > -1)
            .map(broker => ({
                ...broker,
                weeklyAllocation: currentAllocations[broker.brokerId] || 0,
                extraAllocation: extraAllocations[broker.brokerId] || 0,
                dailyCap: dailyCaps[broker.brokerId] || 0,
            }))
            .sort((a, b) => {
                const diff = b.weeklyAllocation - a.weeklyAllocation
                if (diff !== 0) return diff
                const nameA = (a.firstName + ' ' + a.lastName).toLowerCase()
                const nameB = (b.firstName + ' ' + b.lastName).toLowerCase()
                return nameA.localeCompare(nameB)
            })
        setBrokers(resyncedBrokers)
        setUnsavedChanges(false)
        setShowAll(false)
        if (onLiveAllocationsChange) {
            onLiveAllocationsChange(null)
        }
    }, [weekView, nextWeekAllocations])

    let columns = [
        {
            dataField: 'brokerId',
            text: '',
            sort: true,
            editable: false,
            filter: textFilter({ placeholder: 'Search...', style: { width: '90%' } }),
            filterValue: (cell, row) => `${row.firstName} ${row.lastName}`,
            formatter: (cell, row) => {
                return <>{row.firstName + ' ' + row.lastName}</>
            }
        },
        {
            dataField: 'weeklyAllocation',
            text: 'Weekly Allocation',
            sort: true,
            editable: (weekView === 'next-week' && delivery && delivery.active) || canEditThisWeek,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return (
                    <>{row.weeklyAllocation}</>
                )
            }
        },
        ...(weekView !== 'next-week' ? [{
            dataField: 'delivered',
            text: 'Delivered',
            sort: true,
            editable: false,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return (
                    <>{allocated[row.brokerId] ? allocated[row.brokerId] : 0}</>
                )
            }
        }] : []),
        {
            dataField: 'counties',
            text: 'Counties',
            sort: true,
            editable: false,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.counties && row.counties.length > 0 ? row.counties.join(', ') : ''}</>
            }
        }
    ]
    // if replacements (only show in this-week view)
    if (companyDetails.replacementsActive && weekView !== 'next-week') {
        let replacements = {
            dataField: 'extraAllocation',
            text: 'Extra Allocation',
            sort: true,
            editable: false,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return (
                    <>{row.extraAllocation}</>
                )
            }
        }
        columns.splice(2, 0, replacements)
    }
    // if active add daily caps
    if (companyDetails.dailyCapsActive) {
        let dailyCap = {
            dataField: 'dailyCap',
            text: 'Daily Limit',
            sort: true,
            //filter: numberFilter(),
            formatter: (cell, row) => {
                return <>{row.dailyCap}</>
            }
        }
        columns.splice(3, 0, dailyCap)
    }

    const handleTableChange = (type, { data, cellEdit: { rowId, dataField, newValue } }) => {
        console.log(rowId)
        console.log(dataField)
        console.log(newValue)

        // Merge the edit into the full brokers array (data may only contain visible/filtered rows)
        const result = brokers.map((row) => {
            if (row.brokerId === rowId) {
                const newRow = { ...row }
                if (newRow[dataField] !== newValue) {
                    setUnsavedChanges(true)
                }
                newRow[dataField] = newValue
                return newRow
            }
            return row
        })
        console.log('table change result: ', result)
        //setBrokers(result.sort((a, b) => b.weeklyAllocation - a.weeklyAllocation))
        setBrokers(result)
        checkAllocations(result)
        if (onLiveAllocationsChange && weekView === 'next-week') {
            const liveMap = {}
            for (const b of result) {
                liveMap[b.brokerId] = parseInt(b.weeklyAllocation) || 0
            }
            onLiveAllocationsChange(liveMap)
        }
    }

    function checkAllocations(data) {
        let total = 0
        //let hasUnlimited = false
        for (var broker of data) {
            //updatedAllocations[broker.brokerId] = broker['weeklyAllocation']
            let allocation = parseInt(broker['weeklyAllocation'])
            if (allocation !== -1) {
                total += allocation 
            }
        }
        console.log('total: ', total)
        console.log('is nan: ', isNaN(total))
        console.log('weekly limit: ', weeklyLimit)
        // Next week view: any total is valid (broker sets their own allocation)
        // This week view: total must match current weeklyLimit
        if (weekView === 'next-week') {
            if (isNaN(total) || total <= 0) {
                setInvaildAllocations(true)
            } else {
                setInvaildAllocations(false)
            }
        } else {
            if (total !== weeklyLimit || isNaN(total)) {
                setInvaildAllocations(true)
            }
            else {
                setInvaildAllocations(false)
            }
        }
    }

    async function saveAllocations() {
        console.log(brokers)
        let updatedAllocations = {}
        let updatedDailyCaps = {}
        let total = 0
        for (var broker of brokers) {
            updatedAllocations[broker.brokerId] = broker['weeklyAllocation']
            updatedDailyCaps[broker.brokerId] = broker['dailyCap']
            if (parseInt(broker['weeklyAllocation']) !== -1) {
                total += parseInt(broker['weeklyAllocation'])
            }
        }
        console.log('allocations: ', updatedAllocations)
        console.log('daily caps: ', updatedDailyCaps)
        console.log('total: ', total)

        if (weekView === 'next-week') {
            if (!delivery || !delivery.active) {
                NotificationManager.error('This delivery is not active. Allocations cannot be updated.')
                return
            }
            // Next week: save nextAllocation on delivery + broker splits for next week
            if (total > 0 && !isNaN(total)) {
                try {
                    let result = await api.setNextAllocation(companyDetails.companyId, props.product, updatedAllocations)
                    console.log('set next allocation: ', result)
                    if (onDeliveryUpdated && result) {
                        onDeliveryUpdated(result)
                    }
                    setNextWeekAllocations(updatedAllocations)
                    setNextWeekAllocatedIds(new Set(Object.keys(updatedAllocations).filter(id => parseInt(updatedAllocations[id]) > 0)))
                    NotificationManager.success('Next week allocation saved (' + total + ' leads)')
                    setUnsavedChanges(false)
                } catch(e) {
                    onError(e)
                }
            } else {
                NotificationManager.error('Total allocation must be greater than 0')
            }
        } else if (canEditThisWeek) {
            // Localhost or @brokerdiary.io admin: allow direct this-week updates
            if (total > 0 && !isNaN(total)) {
                try {
                    let result = await api.updateAllocations(companyDetails.companyId, props.product, updatedAllocations)
                    console.log('update allocations: ', result)
                    if (companyDetails.dailyCapsActive) {
                        result = await api.updateDailyCaps(companyDetails.companyId, props.product, updatedDailyCaps)
                        console.log('update daily caps: ', result)
                    }
                    NotificationManager.success('Allocations updated')
                    setUnsavedChanges(false)
                } catch(e) {
                    onError(e)
                }
            }
        } else {
            // This week: editing is disabled
            NotificationManager.error('This week\'s allocations cannot be edited. Switch to Next Week to make changes.')
        }
    }

    return (
        <Card>
            {!loading ? (
                <>
                    <CardHeader
                        subheader={
                            <>
                                <Box display='flex' style={{justifyContent: 'space-between'}}>
                                    <Box>
                                        <Box
                                            component={Typography}
                                            variant='h2'
                                            marginBottom='0!important'
                                        >
                                            <Box component='span'>{getProductString(props.product)} Allocations {weekView === 'next-week' ? '(Next Week)' : ''}</Box>
                                        </Box>
                                        <Box
                                            component='p'
                                            fontSize='.875rem'
                                            marginBottom='0'
                                            marginTop='0'
                                            lineHeight='1.7'
                                            fontWeight='300'
                                        >
                                            Click on an allocation or daily limit to make changes
                                        </Box>
                                        {delivery && (
                                            <Box
                                                component='p'
                                                fontSize='.875rem'
                                                marginBottom='0'
                                                marginTop='0.5rem'
                                                lineHeight='1.7'
                                                fontWeight='600'
                                                color={delivery.active ? '#2dce89' : '#f5365c'}
                                            >
                                                {delivery.active ? 'This delivery is active' : 'This delivery is inactive'}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </>
                        }
                        classes={{ root: classes.cardHeaderRoot }}
                    ></CardHeader>

                    {weekView === 'next-week' && !unsavedChanges && (() => {
                        const savedNext = (companyDetails.nextAllocations && companyDetails.nextAllocations[product]) || null
                        if (!savedNext) return null
                        const currentThisWeek = (companyDetails.allocations && companyDetails.allocations[product]) || {}
                        const brokerIdSet = new Set([...Object.keys(savedNext), ...Object.keys(currentThisWeek)])
                        const changes = []
                        for (const brokerId of brokerIdSet) {
                            const oldVal = parseInt(currentThisWeek[brokerId] || 0)
                            const newVal = parseInt(savedNext[brokerId] || 0)
                            if (oldVal !== newVal) {
                                const broker = brokers.find(b => b.brokerId === brokerId)
                                const name = broker ? `${broker.firstName} ${broker.lastName}` : brokerId
                                changes.push({ name, oldVal, newVal })
                            }
                        }
                        if (changes.length === 0) return null
                        changes.sort((a, b) => b.newVal - a.newVal)
                        return (
                            <Box style={{
                                backgroundColor: '#f6f9fc',
                                border: '1px solid #e9ecef',
                                borderRadius: '6px',
                                padding: '12px 16px',
                                margin: '1rem 1.5rem 1rem 1.5rem'
                            }}>
                                <Box style={{fontWeight: 600, marginBottom: '0.5rem', color: '#525f7f'}}>
                                    Saved changes from this week to next week:
                                </Box>
                                {changes.map((c, idx) => (
                                    <Box key={idx} style={{fontSize: '.875rem', color: '#525f7f'}}>
                                        {c.name}: <strong>{c.oldVal}</strong> &rarr; <strong>{c.newVal}</strong>
                                    </Box>
                                ))}
                            </Box>
                        )
                    })()}

                    {(() => {
                        const hasAllocatedBrokers = allocatedBrokerIds.size > 0
                        const hiddenCount = brokers.filter(b => !allocatedBrokerIds.has(b.brokerId)).length
                        const displayBrokers = (hasAllocatedBrokers && hiddenCount > 0 && !showAll)
                            ? brokers.filter(b => allocatedBrokerIds.has(b.brokerId))
                            : brokers
                        return (
                            <>
                                <div className='table-container'>
                                    <BootstrapTable 
                                        keyField='brokerId' 
                                        data={ displayBrokers } 
                                        columns={ columns } 
                                        filter={ filterFactory() } 
                                        noDataIndication={<Box>No brokers</Box>}
                                        cellEdit={ ((weekView === 'next-week' && delivery && delivery.active) || canEditThisWeek) ? cellEditFactory({ mode: 'click', blurToSave: true }) : cellEditFactory({ mode: 'click', blurToSave: true, nonEditableRows: () => brokers.map(b => b.brokerId) }) }
                                        onTableChange={ handleTableChange }
                                        remote={{
                                            filter: false,
                                            pagination: false,
                                            sort: false,
                                            cellEdit: true
                                        }}
                                    />
                                </div>
                                {hasAllocatedBrokers && hiddenCount > 0 && (
                                    <Box display='flex' justifyContent='center' style={{padding: '1rem'}}>
                                        <Button
                                            variant='outlined'
                                            size='medium'
                                            onClick={() => setShowAll(!showAll)}
                                            style={{
                                                color: '#5e72e4',
                                                borderColor: '#5e72e4',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.9rem'
                                            }}
                                        >
                                            {showAll ? 'Hide Brokers With 0 Allocation' : `Show All ${getProductString(product)} Brokers (${hiddenCount} hidden)`}
                                        </Button>
                                    </Box>
                                )}
                            </>
                        )
                    })()}
                    
                    {unsavedChanges &&
                        <Grid container direction='column' justifyContent='center' alignItems='center' spacing={1} style={{margin: '1rem'}}>
                            {invalidAllocations ? (
                                <Grid item xs={12} style={{textAlign: 'center'}}>
                                    {weekView === 'next-week' ? (
                                        <Box class='warning-text'>Total allocation must be greater than 0.</Box>
                                    ) : (
                                        <>
                                            <Box class='warning-text'>Invalid allocations. Values must add up to total weekly allocation ({weeklyLimit}).</Box>
                                            <Box class='warning-text'>Email colm@bq.ie if you need to update your total weekly allocation.</Box>
                                        </>
                                    )}
                                </Grid>
                            ) : (
                                <>
                                <Grid item xs={12} style={{textAlign: 'center'}}>
                                    <Box class='warning-text'>
                                        {weekView === 'next-week' 
                                            ? 'You have unsaved changes to next week\'s allocations'
                                            : 'You have made unsaved changes to your allocations'
                                        }
                                    </Box>
                                </Grid>
                                {weekView === 'next-week' && (() => {
                                    const baseline = savedNextWeekAllocations || {}
                                    const changes = brokers
                                        .map(b => {
                                            const oldVal = parseInt(baseline[b.brokerId] || 0)
                                            const newVal = parseInt(b.weeklyAllocation) || 0
                                            return { broker: b, oldVal, newVal }
                                        })
                                        .filter(c => c.oldVal !== c.newVal)
                                    if (changes.length === 0) return null
                                    changes.sort((a, b) => b.newVal - a.newVal)
                                    return (
                                        <Grid item xs={12} style={{textAlign: 'center', maxWidth: '600px'}}>
                                            <Box style={{
                                                backgroundColor: '#f6f9fc',
                                                border: '1px solid #e9ecef',
                                                borderRadius: '6px',
                                                padding: '12px 16px',
                                                marginTop: '0.5rem'
                                            }}>
                                                <Box style={{fontWeight: 600, marginBottom: '0.5rem', color: '#525f7f'}}>Summary of changes:</Box>
                                                {changes.map((c, idx) => (
                                                    <Box key={idx} style={{fontSize: '.875rem', color: '#525f7f'}}>
                                                        {c.broker.firstName} {c.broker.lastName}: <strong>{c.oldVal}</strong> &rarr; <strong>{c.newVal}</strong>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Grid>
                                    )
                                })()}
                                <Grid item>
                                    <Button
                                        component={Box}
                                        color='primary'
                                        variant='contained'
                                        size='medium'
                                        //disabled={checkRequiredFields()}
                                        onClick={() => saveAllocations()}
                                    >
                                        Save Changes
                                    </Button>
                                </Grid>
                                </>
                            )}
                        </Grid>
                    }
                </>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Card>
    );
}

export default AllocationsTable